export function createLogger(enabled) {
	const isEnabled = Boolean(enabled);

	return {
		debug: (...args) => {
			if (!isEnabled) {
				return;
			}

			// eslint-disable-next-line no-console
			console.debug('[SD WiTechs Configurator]', ...args);
		},
		error: (...args) => {
			// eslint-disable-next-line no-console
			console.error('[SD WiTechs Configurator]', ...args);
		},
	};
}
